/*
 * Exports
 */
export { default } from './components/DigitalNotificationEmail.component';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-notification-email/index.js